import { useState } from 'react';
import { CategoriesTab } from './categories-tab';
import { BrandsTab } from './brands-tab';
import { ColorsTab } from './colors-tab';
import { BannersTab } from './banners-tab';
import { TaxRulesTab } from './tax-rules-tab';
import { CommissionRulesTab } from './commission-rules-tab';
import { PageHeader } from '../../components/page-header';

// The catalog-shaped masters. Each of these already had full CRUD endpoints on
// the API and no screen to reach them from — categories in particular, which
// every product references and which nothing in the console could create.
//
// One route with tabs rather than six sidebar entries: they are edited in the
// same sitting (add a category, then its tax rule, then a banner pointing at
// it) and six near-identical nav links would bury the pages that matter daily.

const TABS = [
  { key: 'categories', label: 'Categories', scope: 'catalog.category.read' },
  { key: 'brands', label: 'Brands', scope: 'catalog.brand.read' },
  { key: 'colors', label: 'Colours', scope: 'master.read' },
  { key: 'banners', label: 'Banners', scope: 'catalog.banner.read' },
  { key: 'tax', label: 'Tax rules', scope: 'catalog.taxrule.read' },
  { key: 'commission', label: 'Commission', scope: 'catalog.commission.read' },
] as const;

type TabKey = (typeof TABS)[number]['key'];

export function CatalogMastersPage() {
  const [tab, setTab] = useState<TabKey>('categories');

  return (
    <div className="space-y-6">
      <PageHeader
        title="Catalog"
        description="Categories, brands, colours and the merchandising rules products are priced and placed against."
      />

      <div role="tablist" aria-label="Catalog sections" className="tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={tab === t.key}
            onClick={() => setTab(t.key)}
            className="tab"
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'categories' && <CategoriesTab />}
      {tab === 'brands' && <BrandsTab />}
      {tab === 'colors' && <ColorsTab />}
      {tab === 'banners' && <BannersTab />}
      {tab === 'tax' && <TaxRulesTab />}
      {tab === 'commission' && <CommissionRulesTab />}
    </div>
  );
}
